import { SiteDataOK } from "../types/SiteData";



const useSiteData = () => {
    const updateSite = async (siteIDs: string[], option: string = "") => { // get the data from the API
        let allPluginData: SiteDataOK[] = [];

        const fetchPromises = siteIDs.map((siteID) => {
            const cmd = option === "force" ? "/?cmd=force" : "";
            return fetch(`${process.env.REACT_APP_API_DOMAIN}/authorized/${siteID}${cmd}`, {
                method: "GET",
                signal: AbortSignal.timeout(5000)
            })
                .then(response => response.json())
                .then((data: SiteDataOK) => {
                    allPluginData.push(data); // adds the data to an array
                })
                .catch(error => {
                    console.log(error);
                });
        });

        // Wait for all fetch calls to complete
        await Promise.all(fetchPromises);
        return allPluginData; // Now, this will have the correct data
    };

    // Get plugin site and give it the plugin name
    const pluginData = async (authorizedList: string[]) => {
        const sites: SiteDataOK[] = await updateSite(authorizedList);
        const pluginsMap: Record<string, string[][]> = {}; // object of all the plugins
        sites.forEach(site => {
            site.plugins.forEach(plugin => {
                const pluginName: string = plugin.name;
                const pluginCurrentVersion: string = plugin.version;
                const pluginLatestVersion: string = plugin.newVersion;
                const pluginInfos = [] // create an array of the site and the version
                if (!pluginsMap[pluginName]) {
                    pluginsMap[pluginName] = []; // creates the plugin array if it doesn't exists already
                    pluginsMap[pluginName].unshift([pluginLatestVersion]); // adds the plugin version to the plugin arraySh
                }
                pluginInfos.push(site.name);
                pluginInfos.push(pluginCurrentVersion);
                pluginInfos.push(site.wpUrl);
                pluginsMap[pluginName].push(pluginInfos); // adds the array of site and version in the plugin array

            });
        });
        // sort object by alphabetical order
        const sortedPluginsMap: any = Object.entries(pluginsMap)
            .sort()
            .reduce((r, [key, value]) => ({ ...r, [key]: value }), {});
        return sortedPluginsMap;
    }

    return { pluginData };
}
export default useSiteData;
